import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class RandomSessionIdService {
    public randomSessionId(length = 50): string {
        return this.randomString(length);
    }
    private randomString(length = 50) {
        return [...Array(length + 10)]
            .map((value) => (Math.random() * 1000000)
                .toString(36)
                .replace('.', ''))
            .join('')
            .substring(0, length);
    };
}
